import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Cookie } from "lucide-react";

export const CONSENT_KEY = "oresto-cookie-consent";
export const getConsent = () => {
  try { return window.localStorage.getItem(CONSENT_KEY); } catch { return null; }
};
export const openCookieSettings = () => window.dispatchEvent(new Event("oresto-open-cookies"));

export default function CookieConsent() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(() => !getConsent());

  useEffect(() => {
    const reopen = () => setOpen(true);
    window.addEventListener("oresto-open-cookies", reopen);
    return () => window.removeEventListener("oresto-open-cookies", reopen);
  }, []);

  const choose = (v) => {
    try { window.localStorage.setItem(CONSENT_KEY, v); } catch {}
    setOpen(false);
    window.dispatchEvent(new Event("oresto-consent"));
  };

  if (!open || pathname.startsWith("/fiduciaire/")) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 sm:inset-x-auto sm:left-4 sm:max-w-md z-[70] bg-white border border-c rounded-2xl shadow-2xl p-3 sm:p-4" style={{ marginBottom: "env(safe-area-inset-bottom)" }} data-testid="cookie-banner" role="dialog" aria-live="polite">
      <div className="flex gap-3">
        <Cookie className="w-5 h-5 text-secondary-c shrink-0 mt-0.5" />
        <p className="text-xs text-text-secondary leading-relaxed">
          {t("cookies.text")} <Link to="/confidentialite" className="text-primary-c underline font-semibold">{t("cookies.more")}</Link>
        </p>
      </div>
      <div className="grid grid-cols-2 gap-2 mt-3">
        <button onClick={() => choose("denied")} data-testid="cookie-refuse" className="btn-secondary !py-2 text-sm">{t("cookies.refuse")}</button>
        <button onClick={() => choose("granted")} data-testid="cookie-accept" className="btn-primary !py-2 text-sm">{t("cookies.accept")}</button>
      </div>
    </div>
  );
}
